import Navbar from "../components/Navbar/Navbar";
import { TermsAndCondition } from "../components/TermsAndCondition";
import "./layout.css";

const AuthFormLayout = (props) => {
  return (
    <>
      <Navbar isFixed isShadowActive />
      <div className="auth-form-layout" style={props.styles}>
        <div className={`col-md-3 ${props.className}`}>{props.children}</div>
        <TermsAndCondition />
      </div>
    </>
  );
};

export default AuthFormLayout;
